import type {
	IGetResultSubscriptionTypeByID,
	IGetResultSubscriptionTypes,
	IResultSubscriptions,
} from '../../../interface/state/IResultSubscription';
import { subscriptionType } from '../../types';
import { getCommandQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

export interface ICreateResultSubscription {
	subscriptionType: string;
	electionId: number;
}

export const create_Subscription = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: ICreateResultSubscription;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/ResultSubscription',
			header: utils.header(),
			data,
		},
		actionType: subscriptionType.create_Subscription,
		onSuccess,
		onFailure,
	});

export const get_Subscription = ({ onFailure, onSuccess, query, paged }: IGetQuery<IResultSubscriptions>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscription${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_Subscription,
		onSuccess,
		onFailure,
	});

export const get_SubscriptionByElection = ({
	onFailure,
	onSuccess,
	electionId,
}: IResponse<IResultSubscriptions> & { electionId: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscription/election/${electionId}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_SubscriptionByElection,
		onSuccess,
		onFailure,
	});

export const get_SubscriptionById = ({ onFailure, onSuccess, id }: IResponse & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscription/${id}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_SubscriptionById,
		onSuccess,
		onFailure,
	});

export const get_SubscriptionDocumentTypeEmails = ({ onFailure, onSuccess, query, paged }: IGetQuery) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscription/document-type-emails${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_SubscriptionDocumentTypeEmails,
		onSuccess,
		onFailure,
	});

export interface IUnsubscribeResultSubscription {
	electionId: number;
	email: string;
	resultType: string;
}

export const unsubscribe_Subscription = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IUnsubscribeResultSubscription;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/ResultSubscription/unsubscribe',
			header: utils.header(),
			data,
		},
		actionType: subscriptionType.unsubscribe_Subscription,
		onSuccess,
		onFailure,
	});

export interface ISubscriptionAddEmails {
	electionId: number;
	subscriptionTypeId: number;
	documentType: string;
	users: {
		email: string;
		name: string;
	}[];
}

export const addEmails_Subscription = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: ISubscriptionAddEmails;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/ResultSubscription/add-emails',
			header: utils.header(),
			data,
		},
		actionType: subscriptionType.addEmails_Subscription,
		onSuccess,
		onFailure,
	});

export interface IRemoveEmailSubscription {
	subscriptionId: string;
	documentType: string;
	email: string;
}

export const removeEmails_Subscription = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: IRemoveEmailSubscription;
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/ResultSubscription/unsubscribe',
			header: utils.header(),
			data,
		},
		actionType: subscriptionType.removeEmails_Subscription,
		onSuccess,
		onFailure,
	});

export const get_SubscriptionType = ({ onFailure, onSuccess, query, paged }: IGetQuery<IGetResultSubscriptionTypes>) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscriptionType${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_SubscriptionType,
		onSuccess,
		onFailure,
	});

export const get_SubscriptionTypeById = ({
	onFailure,
	onSuccess,
	id,
}: IResponse<IGetResultSubscriptionTypeByID> & { id: string }) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/ResultSubscriptionType/${id}`,
			header: utils.header(),
		},
		actionType: subscriptionType.get_SubscriptionTypeById,
		onSuccess,
		onFailure,
	});
